/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import AddressColumn from 'app/shared/components/Analytics/AddressColumn';
import AnalyticsTable from 'app/shared/components/Analytics/Table';
import HeaderTooltip from 'app/shared/components/Analytics/HeaderTooltip';
import BoostAdPreviewLink from 'app/shared/components/BoostAdReport/BoostAdPreviewLink';

import numberUtils from 'app/shared/utils/numberUtils';

const propTypes = {
    boostAdReport: PropTypes.object.isRequired,
    isScreenMobile: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onPropertyClick: PropTypes.func.isRequired,
    onAdClick: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
};

const defaultProps = {
    errorMessage: '',
};

const toolTipMap = {
    boost: 'Z: Zillow + Trulia + HotPads\nFB: Facebook\nIG: Instagram',
    cpc: 'Cost Per Click',
    ctr: 'Click-Through Rate',
};

class BoostAdTable extends React.Component {
    getHeaderList(isMobile, hasAdPreviews) {
        if (isMobile) {
            return ['Property', 'Cost'];
        }
        const columns = ['Property'];
        columns.push(<HeaderTooltip title="Boost Type" message={toolTipMap.boost} />);
        columns.push('Cost');
        columns.push('Impressions');
        columns.push('Website Referrals');
        columns.push(<HeaderTooltip title="CPC" message={toolTipMap.cpc} />);
        columns.push(<HeaderTooltip title="CTR" message={toolTipMap.ctr} />);

        columns.push('');
        return columns;
    }

    getRowList(isMobile, hasAdPreviews) {
        const { boostAdReport, onPropertyClick, onAdClick } = this.props;
        const rows = Object.values(boostAdReport.rows);
        const listings = boostAdReport.propertyDetails;
        return rows.map((row, index) => {
            const listingKey = `${row.feedListingId}_${row.feedId}`;
            const listing = listings[listingKey];
            const rowData = {};
            rowData.property = (
                <AddressColumn
                    index={index}
                    listing={listing}
                    listingKey={listingKey}
                    onClick={listing.hasAccess ? onPropertyClick : undefined}
                />
            );

            if (isMobile) {
                rowData.totalCost = numberUtils.asCurrencyWithDefault(row.totalCost, '-');
                return rowData;
            }

            rowData.boostType = row.boostTypes.join(' + ');
            rowData.totalCost = numberUtils.asCurrencyWithDefault(row.totalCost, '-');
            rowData.impressions = row.impressions;
            rowData.clicks = row.clicks;
            rowData.cpc = numberUtils.asCurrencyWithDefault(row.cpc, '-');
            rowData.ctr = row.ctr;
            rowData.ad = (
                <BoostAdPreviewLink
                    onAdClick={onAdClick}
                    insertionOrderId={row.insertionOrderId}
                />
            );

            return rowData;
        });
    }

    render() {
        const {
            boostAdReport, isLoading, errorMessage, isScreenMobile,
        } = this.props;
        const hasAdPreviews = boostAdReport.rows.some(row => row.active);
        const headerList = this.getHeaderList(isScreenMobile, hasAdPreviews);
        const rowList = this.getRowList(isScreenMobile, hasAdPreviews);

        return (
            <AnalyticsTable
                headerList={headerList}
                rowList={rowList}
                errorMessage={errorMessage}
                isLoading={isLoading}
                emptyMessage="No properties found."
                isEstimate={boostAdReport.isEstimate}
            />
        );
    }
}

BoostAdTable.propTypes = propTypes;
BoostAdTable.defaultProps = defaultProps;

export default BoostAdTable;
